import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { useState } from "react";
import { toast } from "sonner";

interface InventoryModeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedItem: any;
  onConfirm: (countedQuantity: number, notes: string) => void;
}

export const InventoryModeDialog = ({
  open,
  onOpenChange,
  selectedItem,
  onConfirm,
}: InventoryModeDialogProps) => {
  const [countedQuantity, setCountedQuantity] = useState("");
  const [notes, setNotes] = useState("");

  const handleSubmit = () => {
    const quantity = parseInt(countedQuantity);
    if (isNaN(quantity) || quantity < 0) {
      toast.error("Veuillez entrer une quantité valide");
      return;
    }

    onConfirm(quantity, notes);
    setCountedQuantity("");
    setNotes("");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Comptage d'inventaire - {selectedItem?.data?.name}</DialogTitle>
          <DialogDescription>
            Entrez la quantité comptée physiquement pour ce produit
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <label className="text-sm font-medium">
              Quantité système actuelle
            </label>
            <p className="text-sm text-muted-foreground">
              {selectedItem?.quantity} {selectedItem?.data?.unit || 'unités'}
            </p>
          </div>
          <div className="space-y-2">
            <label className="text-sm font-medium">
              Quantité comptée
            </label>
            <Input
              type="number"
              value={countedQuantity}
              onChange={(e) => setCountedQuantity(e.target.value)}
              placeholder="Entrez la quantité comptée"
              min="0"
            />
          </div>
          <div className="space-y-2">
            <label className="text-sm font-medium">
              Notes (optionnel)
            </label>
            <Input
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Ajoutez des notes si nécessaire"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Annuler
          </Button>
          <Button onClick={handleSubmit}>
            Confirmer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};